module.exports = __webpack_public_path__ + "img/school-load.08650f7a.gif";